/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from "../../../../../app/modules/auth";

const SidebarMenuMain = () => {
    const {currentUser} = useAuth();
    const multipleExist =(arr) => currentUser?.roles?.every(value => {
        return arr.includes(value);
    });
  return (
    <>
        { multipleExist(['Admin','Partner'])  && (
            <SidebarMenuItem
                to='/dashboard'
                icon='element-11'
                title="داشبورد"
                fontIcon='bi-app-indicator'
            />
        )}

      {/*<SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />*/}
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>پنل مدیریت</span>
        </div>
      </div>
        {multipleExist(['Admin','Partner']) && (
            <SidebarMenuItemWithSub
                to='/crafted/accounts'
                title='تنظیمات'
                icon='setting-2'
                fontIcon='bi-database-gear'
            >

                <SidebarMenuItem to='/apps/Menu/Menus' title='منو' hasBullet={true} />
                <SidebarMenuItem to='/apps/BaseConfig/config' title='تنظیمات نرم افزار' hasBullet={true} />
                {
                    currentUser?.roles?.includes('Admin' ) && (
                        <>
                            <SidebarMenuItem to='/apps/Users/Lists' title='مدیریت کاربران' hasBullet={true} />
                            <SidebarMenuItem to='/Authorize/List' title='مدیریت کلید ها' hasBullet={true} />
                        </>

                    )
                }


                <SidebarMenuItem to='/apps/Advertising/' title='مدیریت تبلیغات' hasBullet={true} />
            </SidebarMenuItemWithSub>
        )}
        {multipleExist(['Admin','Partner','Writer'])  && (
            <SidebarMenuItemWithSub
                to='/apps/posts'
                title='پست '
                icon='pencil'
                fontIcon='bi-person'
            >
                <SidebarMenuItem to='/apps/PostTypes/List' title='دسته بندی پست ها' hasBullet={true} />
                <SidebarMenuItem to='/apps/Post/List' title=' پست ها' hasBullet={true} />
                <SidebarMenuItem to='/apps/FeedReader/List' title=' خوراک ها' hasBullet={true} />

            </SidebarMenuItemWithSub>
        )}

        {multipleExist(['Admin','Partner'])  && (
            <SidebarMenuItemWithSub
                to='/apps/Page'
                title='صفحه '
                icon='abstract-26'
                fontIcon='bi-person'
            >
                {/*<SidebarMenuItem to='/apps/PostTypes/List' title='دسته بندی پست ها' hasBullet={true} />*/}
                <SidebarMenuItem to='/apps/Page/List' title=' صفحه ها' hasBullet={true} />
                <SidebarMenuItem to='/apps/Element/List' title=' المنت ها' hasBullet={true} />

            </SidebarMenuItemWithSub>
        )}
        {multipleExist(['Admin','Partner'])  && (
            <SidebarMenuItemWithSub
                to='/Product/store'
                title='محصولات '
                icon='abstract-26'
                fontIcon='bi-person'
            >
                <SidebarMenuItem to='/Product/Store/List' title='محصولات' hasBullet={true} />
                <SidebarMenuItem to='/Product/Category/List' title=' دسته بندی ها' hasBullet={true} />
                <SidebarMenuItem to='/Product/Brand/List' title='برند ها' hasBullet={true} />
                <SidebarMenuItem to='/Product/ProductPropertyGroup/List' title='گروه ویژگی ها' hasBullet={true} />
                <SidebarMenuItem to='/Product/PropertyName/List' title=' ویژگی ها' hasBullet={true} />

            </SidebarMenuItemWithSub>
        )}

      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='حساب کاربری'
        icon='profile-circle'
        fontIcon='bi-person'
      >

        <SidebarMenuItem to='/crafted/account/overview' title='اطلاعات کاربری' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='تنظیمات' hasBullet={true} />
      </SidebarMenuItemWithSub>
      {/*<SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>*/}
      {/*  <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />*/}
      {/*  <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />*/}
      {/*</SidebarMenuItemWithSub>*/}


    </>
  )
}

export {SidebarMenuMain}
